// Product brief for traditional / standalone LTC (and CareScout Care Assurance).
// See cmTwo.ts for the format intent.

export const traditionalLtcBrief = `**Traditional / standalone LTC insurance** — generic reimbursement product.
Also models CareScout Care Assurance (identical calc path).

Pool model — **single pool, no death benefit**:
- \`policyMaximumBenefitAmount\` IS the lifetime LTC dollar pool (the "Coverage
  Maximum"). It seeds the \`base_pool\` (less prior utilization).
- There is **no second pool** — \`eob\` is $0 on every row.
- There is **no death benefit** — the \`db\` column is $0 throughout, and
  "Remaining death benefit" in the returns summary is $0. Any DB drawdown or
  non-zero DB indicates the wrong product mechanics.

Daily-cap inflation:
- The monthly cap = daily benefit × the simple-or-compound inflation factor at
  the policy anniversary, anchored to at-issue (the \`inflation_rate\` header says
  simple or compound and includes the cap year). The cap steps up each
  anniversary until the inflation cap year.
- On traditional LTC, inflation also grows the remaining Coverage Maximum /
  \`base_pool\`; compound inflation grows the remaining balance, while simple
  inflation adds a fixed at-issue-based step.

Payout model — reimbursement (default) or cash indemnity:
- **Reimbursement** (default): pays min(eligible cost, pro-rated daily cap) from
  the pool. Care cost above the cap is out-of-pocket — expect non-zero
  \`ineligible\` whenever monthly care cost exceeds the cap.
- **Indemnity** (election): pays min(pro-rated cap, pool remaining) as cash
  regardless of actual cost, from the single pool.

Elimination period:
- Elimination-period days are out-of-pocket (\`in-wp\` rows). No retroactive lump.

Things to eyeball:
- \`eob\` and \`db\` are $0 on every row — single pool, no death benefit.
- Out-of-pocket appears whenever care cost exceeds the inflated monthly cap.
- Pool drawdown equals dollars paid (no indemnity-surplus / rider-on-top gap)
  under reimbursement.
- For CareScout, \`dailyHomeBenefitAmount\` assumes Agency Home Care. Independent
  Provider Home Care's 50% haircut is not represented by this strategy.
`;
